import { render, staticRenderFns } from "./TicketBook.vue?vue&type=template&id=05a225dc&scoped=true&"
import script from "./TicketBook.vue?vue&type=script&lang=js&"
export * from "./TicketBook.vue?vue&type=script&lang=js&"
import style0 from "./TicketBook.vue?vue&type=style&index=0&id=05a225dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a225dc",
  null
  
)

export default component.exports